import React from 'react'
import NotFound from '../notfound'

const NotFoundEs = () => {
    return <NotFound languageCode="es" />
}

export default NotFoundEs
